import {OrderingTypes, RestaurantTypes} from 'new-constants/common.constants';
import {getSafeTranslation} from 'helpers/localization.helper.ts';

export const isRestaurantPickup = function (restaurant) {
	return (
		restaurant.restaurantType !== RestaurantTypes.PRE_ORDER_ONLY_DELIVERY &&
		restaurant.restaurantType !== RestaurantTypes.TABLE_SERVING &&
		restaurant.restaurantType !== RestaurantTypes.DINE_IN &&
		restaurant.restaurantType !== RestaurantTypes.PRE_ORDER_ONLY_DINE_IN
	);
};

export const isRestaurantDelivery = function (restaurant) {
	return (
		restaurant.isHomeDeliveryEnabled &&
		restaurant.restaurantType !== RestaurantTypes.PRE_ORDER &&
		restaurant.restaurantType !== RestaurantTypes.TABLE_SERVING &&
		restaurant.restaurantType !== RestaurantTypes.DINE_IN &&
		restaurant.restaurantType !== RestaurantTypes.PRE_ORDER_ONLY_DINE_IN
	);
};

export const isRestaurantDineIn = function (restaurant) {
	return (
		restaurant.restaurantType === RestaurantTypes.TABLE_SERVING ||
		restaurant.restaurantType === RestaurantTypes.DINE_IN ||
		restaurant.restaurantType === RestaurantTypes.PRE_ORDER_ONLY_DINE_IN
	);
};

export const OrderingTypeFilters = {
	[OrderingTypes.pickup]: isRestaurantPickup,
	[OrderingTypes.delivery]: isRestaurantDelivery,
	[OrderingTypes.dineIn]: isRestaurantDineIn,
};

export const getAvailableOrderingTypes = function (restaurant) {
	if (!restaurant) return [];

	const orderingTypes = [];

	if (isRestaurantPickup(restaurant)) {
		orderingTypes.push(OrderingTypes.pickup);
	}

	if (isRestaurantDelivery(restaurant)) {
		orderingTypes.push(OrderingTypes.delivery);
	}

	if (isRestaurantDineIn(restaurant)) {
		orderingTypes.push(OrderingTypes.dineIn);
	}

	return orderingTypes;
};

export const getScheduleString = function (schedule, translations) {
	if (!schedule) return null;

	const {startPickup, stopPickup, openAllDay, closeAllDay} = schedule;

	if (closeAllDay) {
		return getSafeTranslation('LocationCard.closedLabel', translations);
	} else if (startPickup && stopPickup && !openAllDay) {
		return getSafeTranslation('LocationCard.openHoursLabel', translations)
			.replace('{startPickup}', startPickup)
			.replace('{stopPickup}', stopPickup);
	} else {
		return getSafeTranslation('LocationCard.openLabel', translations);
	}
};

export const getDeliveryTimeString = function (location, translations) {
	if (!location && !location.todaySchedule) return null;

	const {startDelivery, stopDelivery, closeAllDay, openAllDay} = location.todaySchedule;

	if (openAllDay) {
		return getSafeTranslation('LocationCard.openLabel', translations);
	}

	if (
		closeAllDay ||
		(!startDelivery && !stopDelivery)
	) {
		return getSafeTranslation('LocationCard.closedLabel', translations);
	}

	if (!location.isHomeDeliveryEnabled) {
		return getSafeTranslation('LocationCard.deliveryDisabledLabel', translations);
	}

	if (startDelivery && stopDelivery) {
		return getSafeTranslation('LocationCard.deliveryHoursLabel', translations)
			.replace('{startDelivery}', startDelivery)
			.replace('{stopDelivery}', stopDelivery)
	}

	return getSafeTranslation('LocationCard.openLabel', translations);
}

export const isRestaurantOpen = function (currentCustomer, currentRestaurant) {
	if (!currentCustomer?.restaurant || !currentRestaurant) return false;

	return (
		currentCustomer?.restaurant?.isOpen ||
		(currentRestaurant?.isFutureOrdersAllowed &&
			!currentCustomer?.restaurant?.isTemporaryStopOrders &&
			!currentCustomer?.restaurant?.isTooBusyForNewOrders)
	);
};

export const isNotPossibleToChooseTime = function (currentRestaurant, orderTime) {
	if (!currentRestaurant) return false;

	return currentRestaurant.possibleToGivePickupTime && orderTime.dates.length === 1 && orderTime.timeSlots.length === 0;
};
